module.exports = __webpack_public_path__ + "static/media/kaitsu.105e3fa3.png";